import { Component, inject, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SettlementsService } from 'src/app/services/settlements.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: '[app-nav-payments]',
  template: `
    <li><button #receipts class="btn btn-zazz-default active rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/pagos/pendientes">Recibos no emitidos</button></li>
    <li><button #bills class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/pagos/recibos">Recibos no pagados</button></li>
    <li><button #payments class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/pagos">Recibos pagados</button></li>
    <li><button #balance class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/pagos/balances">Saldos</button></li>
  `,
  styles: ``
})
export class NavPaymentsComponent {
  @Input() currentView: string | null = null;
  profile: any = {};

  @ViewChild('receipts') receipts !: any;
  @ViewChild('bills') bills !: any;
  @ViewChild('payments') payments !: any;
  @ViewChild('balance') balance !: any;
  
  storageService = inject(StorageService);
  constructor(
    private store: SettlementsService,
    private router: Router
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
  }

  ngAfterViewInit() {
    if (!this.currentView) return;
    if (this.currentView === 'receipts') {
      this.receipts.nativeElement.classList.add('active');
      this.bills.nativeElement.classList.remove('active');
      this.payments.nativeElement.classList.remove('active');
      this.balance.nativeElement.classList.remove('active');
    } else if (this.currentView === 'bills') {
      this.receipts.nativeElement.classList.remove('active');
      this.bills.nativeElement.classList.add('active');
      this.payments.nativeElement.classList.remove('active');
      this.balance.nativeElement.classList.remove('active');
    } else if (this.currentView === 'payments') {
      this.receipts.nativeElement.classList.remove('active');
      this.bills.nativeElement.classList.remove('active');
      this.payments.nativeElement.classList.add('active');
      this.balance.nativeElement.classList.remove('active');
    } else if (this.currentView === 'balance') {
      this.receipts.nativeElement.classList.remove('active');
      this.bills.nativeElement.classList.remove('active');
      this.payments.nativeElement.classList.remove('active');
      this.balance.nativeElement.classList.add('active');
    }
  }
}
